import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, firstValueFrom, of } from 'rxjs';
import { toDataURL } from '../utils/traversing';

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {

  private cache = new Map<string, Promise<any>>();
  private httpClient: HttpClient;

  constructor(
    private handler: HttpBackend,
  ) {
    this.httpClient = new HttpClient(handler);
  }

  getImageData(src: string, iam?: string): Promise<any> {
    if (src?.startsWith('data:')) {
      return Promise.resolve({
        result: src,
        encoded: src.replace(/^data:(.*;base64,)?/, '')
      });
    }

    if (this.cache.has(src)) {
      return this.cache.get(src)!;
    }

    if (iam == null) {
      iam = localStorage.getItem("googleToken");
    }

    const headers = new HttpHeaders({ 'Authorization': `Bearer ${iam}` });

    const imagePromise = firstValueFrom(
      this.httpClient.get(src, { headers, responseType: 'blob' }).pipe(
        catchError(() => {
          return of({ type: 'error' });
        })
      )
    ).then(imageBlob => {
      if (!imageBlob.type || imageBlob.type === 'error') {
        return { type: 'error' };
      }
      return toDataURL(imageBlob);
    });

    this.cache.set(src, imagePromise);
    return imagePromise;
  }
}
